import type { SelectOption } from '../Select/SelectOption/SelectOption';
import { stringIncludesQuery } from './stringIncludesQuery';

export function baseOptionComparator(
  option: SelectOption,
  query: string
): boolean {
  return stringIncludesQuery(option.label, query);
}
